import {ElementInputAutocomplete} from './element-input-autocomplete';

export class ElementInputAlgoliaPlaces extends ElementInputAutocomplete {
  public constructor() {
    super();

    this.typeElement = 'algoliaPlaces';
  }
}
